import React, { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { CONFIG } from "../../../app-config";
import { UTM_API_ENDPOINT } from "../../../constant";
import thumpsup from "../../../assets/thumbsup.png";
import useGTM from "../../../custom-hooks/gtm-hook";
import "./ThankYouV2.css";

export default function ThankYouV2({ utm }) {
  const { pushGTMEvent } = useGTM();

  const sendUTMData = async (utmData) => {
    try {
      const response = await axios.post(`${CONFIG.API_PATH_V2}${UTM_API_ENDPOINT.UTM_ENDPOINT}`, utmData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      toast.error("Failed to send UTM data");
      console.error("UTM API Error:", error);
      if (error.response) {
        console.log("UTM API Error Response:", error.response);
      }
    }
  };

  useEffect(() => {
    if (utm) {
      const utmData = {
        utm_code: utm,
        client_url: "",
      };
      sendUTMData(utmData);
    }
  }, [utm]);

  return (
    <div className="thank-you-container mt-3">
      <div className="thank-you-card">
        <div className="thank-you-content">
          <img src={thumpsup} alt="Thumbs Up" className="thank-you-image" style={{ width: '110px', height: '110px' }} />
          <h2 className="thank-you-heading mt-4">Thank You!</h2>
          <p className="thank-you-message">
            Thank you for your interest and trust in us.
          </p>
          <p className="thank-you-message">
            Due to a high volume of requests, we have temporarily disabled auto panel creation.
          </p>
          <p className="thank-you-message">
            Our team will review your request and get back to you soon.
          </p>
          <p className="thank-you-message">
            For urgent inquiries, feel free to reach out via{" "}
            <a href="mailto:sales@blinkexam.com">sales@blinkexam.com</a> or call us at{" "}
            <a href="tel:+919582874969">+919582874969</a>.
          </p>
        </div>
      </div>
    </div>
  );
}